"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _components = require("@folio/stripes/components");
var _validators = require("../../validators");
var _customProperties = require("../../constants/customProperties");
var _hooks = require("../../hooks");
var _NumberField = _interopRequireDefault(require("../../NumberField"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CustomPropertyForm = _ref => {
  let {
    contextFilterOptions,
    helpPopovers,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    refdata
  } = _ref;
  const {
    values
  } = (0, _reactFinalForm.useFormState)();
  const {
    change
  } = (0, _reactFinalForm.useForm)();
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const booleanToString = booleanValue => booleanValue?.toString();
  const stringToBoolean = stringValue => stringValue === 'true';
  const [contextOptions, setContextOptions] = (0, _react.useState)(contextFilterOptions?.filter(ctx => ctx.value !== '' && ctx?.value !== 'isNull'));
  const addCtx = _ref2 => {
    let {
      _r,
      _e,
      filterText
    } = _ref2;
    const newOption = {
      value: filterText,
      label: filterText
    };
    setContextOptions([newOption, ...contextOptions]);
    change('ctx', [newOption]);
  };
  const renderAddCtx = _ref3 => {
    let {
      filterValue,
      exactMatch
    } = _ref3;
    if (!filterValue || exactMatch) {
      return null;
    } else {
      return kintIntl.formatKintMessage({
        id: 'customProperties.ctx.addContext',
        overrideValue: labelOverrides?.addCtx
      }, {
        value: filterValue
      });
    }
  };
  const primaryRetiredValidator = (_v, allValues) => {
    if (allValues.primary && allValues.retired) {
      return kintIntl.formatKintMessage({
        id: 'customProperties.errors.primaryRetired',
        overrideValue: labelOverrides?.primaryRetired
      });
    }
    return null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.Select,
          dataOptions: [{
            label: '',
            value: ''
          }, {
            label: kintIntl.formatKintMessage({
              id: `customProperties.type.${_customProperties.DECIMAL_CLASS_NAME}`,
              overrideValue: labelOverrides?.[_customProperties.DECIMAL_CLASS_NAME]
            }),
            value: _customProperties.DECIMAL_CLASS_NAME
          }, {
            label: kintIntl.formatKintMessage({
              id: `customProperties.type.${_customProperties.INTEGER_CLASS_NAME}`,
              overrideValue: labelOverrides?.[_customProperties.INTEGER_CLASS_NAME]
            }),
            value: _customProperties.INTEGER_CLASS_NAME
          }, {
            label: kintIntl.formatKintMessage({
              id: `customProperties.type.${_customProperties.TEXT_CLASS_NAME}`,
              overrideValue: labelOverrides?.[_customProperties.TEXT_CLASS_NAME]
            }),
            value: _customProperties.TEXT_CLASS_NAME
          }, {
            label: kintIntl.formatKintMessage({
              id: `customProperties.type.${_customProperties.REFDATA_CLASS_NAME}`,
              overrideValue: labelOverrides?.[_customProperties.REFDATA_CLASS_NAME]
            }),
            value: _customProperties.REFDATA_CLASS_NAME
          }, {
            label: kintIntl.formatKintMessage({
              id: `customProperties.type.${_customProperties.MULTI_REFDATA_CLASS_NAME}`,
              overrideValue: labelOverrides?.[_customProperties.MULTI_REFDATA_CLASS_NAME]
            }),
            value: _customProperties.MULTI_REFDATA_CLASS_NAME
          }, {
            label: kintIntl.formatKintMessage({
              id: `customProperties.type.${_customProperties.DATE_CLASS_NAME}`,
              overrideValue: labelOverrides?.[_customProperties.DATE_CLASS_NAME]
            }),
            value: _customProperties.DATE_CLASS_NAME
          }],
          disabled: !!values?.id,
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.type',
              overrideValue: labelOverrides?.type
            }), helpPopovers?.type ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.type
            }) : null]
          }),
          name: "type",
          required: true,
          validate: _validators.required
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: (values?.type === _customProperties.REFDATA_CLASS_NAME || values?.type === _customProperties.MULTI_REFDATA_CLASS_NAME) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.Select,
          dataOptions: [{
            label: '',
            value: ''
          }, ...refdata],
          disabled: !!values?.id,
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.category',
              overrideValue: labelOverrides?.category
            }), helpPopovers?.category ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.category
            }) : null]
          }),
          name: "category",
          required: true,
          validate: _validators.required
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.TextField,
          id: "custom-prop-label",
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.label',
              overrideValue: labelOverrides?.label
            }), helpPopovers?.label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.label
            }) : null]
          }),
          name: "label",
          required: true,
          validate: _validators.required
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.TextField,
          id: "custom-prop-name",
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.name',
              overrideValue: labelOverrides?.name
            }), helpPopovers?.name ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.name
            }) : null]
          }),
          name: "name",
          required: true,
          validate: v => {
            if (v && v.length) {
              return /^[a-z][a-z0-9]*$/i.test(v) ? undefined : kintIntl.formatKintMessage({
                id: 'errors.hasNonAlphaName',
                overrideValue: labelOverrides?.hasNonAlphaName
              });
            }
            return (0, _validators.required)(v);
          }
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.TextArea,
          id: "custom-prop-description",
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.description',
              overrideValue: labelOverrides?.description
            }), helpPopovers?.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.description
            }) : null]
          }),
          name: "description",
          required: true
          // FIXME I think the required Validator might pose translation problems
          ,
          validate: _validators.required
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          actions: [{
            onSelect: addCtx,
            render: renderAddCtx
          }],
          component: _components.MultiSelection,
          dataOptions: contextOptions,
          emptyMessage: kintIntl.formatKintMessage({
            id: 'customProperties.noCtxFound',
            overrideValue: labelOverrides?.noCtxFound
          }),
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.ctx',
              overrideValue: labelOverrides?.ctx
            }), helpPopovers?.ctx ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.ctx
            }) : null]
          }),
          name: "ctx",
          onChange: selectedItems => {
            if (selectedItems.length) {
              change('ctx', [selectedItems?.[selectedItems?.length - 1]]);
            } else {
              change('ctx', undefined);
            }
          }
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 3,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _NumberField.default,
          id: "custom-prop-weight",
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.weight',
              overrideValue: labelOverrides?.weight
            }), helpPopovers?.weight ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.weight
            }) : null]
          }),
          name: "weight",
          required: true,
          validate: _validators.required
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 3,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.Select,
          dataOptions: [{
            label: kintIntl.formatKintMessage({
              id: 'yes',
              overrideValue: labelOverrides?.yes
            }),
            value: 'true'
          }, {
            label: kintIntl.formatKintMessage({
              id: 'no',
              overrideValue: labelOverrides?.no
            }),
            value: 'false'
          }],
          format: booleanToString,
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.primary',
              overrideValue: labelOverrides?.primary
            }), helpPopovers?.primary ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.primary
            }) : null]
          }),
          name: "primary",
          parse: stringToBoolean,
          required: true,
          validate: (0, _validators.composeValidators)(_validators.required, primaryRetiredValidator)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 3,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.Select,
          dataOptions: [{
            label: kintIntl.formatKintMessage({
              id: 'yes',
              overrideValue: labelOverrides?.yes
            }),
            value: 'true'
          }, {
            label: kintIntl.formatKintMessage({
              id: 'no',
              overrideValue: labelOverrides?.no
            }),
            value: 'false'
          }],
          format: booleanToString,
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.retired',
              overrideValue: labelOverrides?.retired
            }), helpPopovers?.retired ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.retired
            }) : null]
          }),
          name: "retired",
          parse: stringToBoolean,
          required: true,
          validate: (0, _validators.composeValidators)(_validators.required, primaryRetiredValidator)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 3,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
          component: _components.Select,
          dataOptions: [{
            label: kintIntl.formatKintMessage({
              id: 'customProperties.internalTrue',
              overrideValue: labelOverrides?.internalTrue
            }),
            value: 'true'
          }, {
            label: kintIntl.formatKintMessage({
              id: 'customProperties.internalFalse',
              overrideValue: labelOverrides?.internalFalse
            }),
            value: 'false'
          }],
          format: booleanToString,
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.defaultVisibility',
              overrideValue: labelOverrides?.defaultVisibility
            }), helpPopovers?.defaultVisibility ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.defaultVisibility
            }) : null]
          }),
          name: "defaultInternal",
          parse: stringToBoolean,
          required: true,
          validate: _validators.required
        })
      })]
    })]
  });
};
CustomPropertyForm.propTypes = {
  contextFilterOptions: _propTypes.default.arrayOf(_propTypes.default.object),
  helpPopovers: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  refdata: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = exports.default = CustomPropertyForm;